/** @format */

const mostRelevant = 'Most Relevant';
const topSellers = 'Top Sellers';
const savingsHighToLow = 'Savings High to Low';
const priceLowToHigh = 'Price Low to High';
const priceHighToLow = 'Price High to Low';
const featured = 'Featured';
const newProducts = 'New Products';
const brandAZ = 'Brand (A-Z)';
const featuredSort = 'Featured Sort';
const topRated = 'Top Rated';

export const plpDefaultSortMap: { [key: string]: number } = {
  ['0']: 0,
  ['5']: 1,
  ['12']: 2,
  ['8']: 3,
  ['9']: 4,
  ['10']: 5,
  ['11']: 6,
  ['6']: 7,
};

/** Serach Result drop down values order */
export const searchDropdownValues: { label: string; value: number }[] = [
  { label: mostRelevant, value: 0 },
  { label: topSellers, value: 1 },
  { label: savingsHighToLow, value: 2 },
  { label: priceLowToHigh, value: 3 },
  { label: priceHighToLow, value: 4 },
  { label: newProducts, value: 6 },
  { label: brandAZ, value: 7 },
];

/** family page drop down values order */
export const familyPageDropdownValues = [
  { label: mostRelevant, value: 0 },
  { label: topSellers, value: 1 },
  { label: savingsHighToLow, value: 2 },
  { label: priceLowToHigh, value: 3 },
  { label: priceHighToLow, value: 4 },
  { label: featured, value: 5 },
  { label: newProducts, value: 6 },
  { label: brandAZ, value: 7 },
];

export const topRatedSort = { label: topRated, value: 8 };

/** sort method dropdown values for analytics */
// 5 and 7 analytics value is not the same as the text in the UI
export const analyticsSortMethodValues = [
  { value: 0, text: mostRelevant },
  { value: 1, text: topSellers },
  { value: 2, text: savingsHighToLow },
  { value: 3, text: priceLowToHigh },
  { value: 4, text: priceHighToLow },
  { value: 5, text: featuredSort },
  { value: 6, text: newProducts },
  { value: 7, text: brandAZ },
  { value: 8, text: topRated },
];
